import React, { useEffect, useState } from 'react';
import { api, getApiBaseUrl } from '../api/client';

const DEFAULT_PHOTOS = [
  { id: 'public-1', url: '/assets/image/r1.jpeg', name: 'Revival Pharmacy' },
];

export default function GalleryPage() {
  const [photos, setPhotos] = useState([]);
  const [error, setError] = useState('');

  const getPhotoUrl = (url) => (
    url.startsWith('http')
      ? url
      : `${getApiBaseUrl().replace(/\/api\/?$/, '')}${url}`
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    api.gallery()
      .then(({ items }) => setPhotos(items.length ? items : DEFAULT_PHOTOS))
      .catch((requestError) => {
        setPhotos(DEFAULT_PHOTOS);
        setError(requestError.message);
      });
  }, []);

  return (
    <div className="department_listing">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="heading">
                        <h1>OUR <span>Gallery</span></h1>
                    </div>
                </div>
            </div>
            <div className="row gallery-grid">
                {error && <div className="col-lg-12"><p role="alert">{error}</p></div>}
                {photos.map((photo) => (
                    <div className="col-12 col-sm-6 col-lg-4 gallery-grid-item" key={photo.id}>
                        <div className="department_list_inner">
                            <div className="image">
                                <img
                                    src={getPhotoUrl(photo.url)}
                                    className="img-fluid"
                                    alt={photo.name || 'Revival Pharmacy gallery'}
                                    onError={(event) => {
                                      event.currentTarget.onerror = null;
                                      event.currentTarget.src = '/assets/image/r1.jpeg';
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
  );
}
